import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
   return twMerge(clsx(inputs));
}

export function formatPhoneNumber(phone: string) {
   phone = phone.replace(/\s+/g, "");

   if (phone.startsWith("+98")) {
      return phone;
   }

   if (phone.startsWith("0")) {
      return "+98" + phone.substring(1);
   }

   return "+98" + phone;
}

export async function createHmacSHA256(input: string) {
   const encoder = new TextEncoder();
   const data = encoder.encode(input);
   const hashBuffer = await crypto.subtle.digest("SHA-256", data);
   return Buffer.from(hashBuffer).toString("hex");
}

export function formatPrice(amount: number | string): string {
   if (!amount) return "0";

   const num = typeof amount === "number" ? amount : parseFloat(amount);
   return num.toLocaleString("fa-IR");
}

function serializeProduct(product: any) {
   return {
      ...product,
      _id: product._id.toString(),
      categoryParent: {
         ...product.categoryParent,
         _id: product.categoryParent._id.toString(),
      },
      categoryChild: {
         ...product.categoryChild,
         _id: product.categoryChild._id.toString(),
      },
   };
}

export const formatNerkh: any = {
   nearest: "نزدیک‌ترین مقدار",
   up: "گرد کردن به بالا",
   down: "گرد کردن به پایین",
};

export const roles: any = {
   user: "کاربر عادی",
   vendor: "فروشنده",
   support: "پشتیبانی",
   moderator: "مدیر محتوا",
   admin: "ادمین",
   superadmin: "superadmin",
};

export const deliveryMethod: any = {
   automatic: "خودکار",
   manual: "دستی",
};
export const glassStyle = "bg-white/10 border border-white/20 backdrop-blur-md shadow-md rounded-xl";

export function generateSixDigitCode(): string {
   return Math.floor(100000 + Math.random() * 900000).toString();
}
